<template>
    <div>
        <div class="col-12 mb-4 d-sm-flex justify-content-sm-between align-items-sm-baseline">
            <h4>Product types</h4>
            <button @click="newProductType"
                    :disabled="loading"
                    class="btn btn-primary">
                New product type
            </button>
        </div>
        <AppTable :columns="columns"
                  :rows="productTypes"
                  :query="query"
                  @on-row-click="viewProductType"
                  :loading="loading"
                  :total="total"
                  @on-query-change="onQueryChange"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
  },
  computed: {
    ...mapGetters({
      productTypes: 'productTypes/productTypes',
    }),
    ...mapState({
      query: (state) => state.productTypes.query,
      total: (state) => state.productTypes.totalProductTypes,
    }),
    columns() {
      return [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getProductTypes();
  },
  methods: {
    newProductType() {
      this.$router.push({
        name: 'product-type',
        params: { id: 'new' },
      });
    },
    getProductTypes() {
      this.loading = true;
      this.$store.dispatch('productTypes/getProductTypes')
        .finally(() => {
          this.loading = false;
        });
    },
    viewProductType(event) {
      this.$router.push({
        name: 'product-type',
        params: { id: event.row.id },
      });
    },

    onQueryChange(props) {
      this.$store.commit('productTypes/queryProps', props);
      this.getProductTypes();
    },
  },
};
</script>
